<app-dialog-header [title]="'general.api_json_difference_modal_title'"></app-dialog-header>
<mat-dialog-content>
  <mat-slide-toggle class="wrap-toggle-text" (change)="toggleShowChangesOnly()" [checked]="showChangesOnly">
    {{ 'general.api_json_difference_modal_show_changes_only_toggle' | translate }}
  </mat-slide-toggle>
  <hr class="slim">
  <div class="pre-wrapper">
    <ng-container *ngIf="showChangesOnly">
      <ng-container *ngFor="let change of changes">
        <pre *ngIf="change.added || change.removed" [ngClass]="change.added ? 'text-success' : 'text-warning'">{{change.value}}</pre>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!showChangesOnly">
      <ng-container *ngFor="let change of changes">
        <pre [ngClass]="change.added ? 'text-success' : (change.removed ? 'text-warning' : '')">{{change.value}}</pre>
      </ng-container>
    </ng-container>
  </div>
  <br>
</mat-dialog-content>
<app-dialog-footer></app-dialog-footer>
